const Textpresso = () => {
  return (
    <div>
      <h4>Textpresso flags go here</h4>
      <p>Text mining information from Textpresso</p>
    </div>
  )
}

export default Textpresso
